<div style="width: 100%">
  <div class="header">
    <div class="navigation">
      <app-breadcrumb />
    </div>

    <app-risk-score-diagram />
  </div>
  <div class="row">
    <div class="titles-container">
      <h1 class="subtitle">
        {{ title }}
      </h1>
      <h2 class="title">
        {{ complianceElement.name | desanitize }}
      </h2>
    </div>
  </div>

  <div class="row">
    <span class="filters">
      <span class="compare-data">
        <!-- compare visualization -->
        <span class="filter-title">Comparing {{ type }}s: </span>
        <!-- Regions pill -->
        <span class="pill">
          {{ elements[0]?.code }}/{{ elements[1]?.code }}
          <button
            type="button"
            aria-label="Clear regions filter"
            (click)="clearCompare()"
          >
            X
          </button>
        </span>
      </span>
      <app-filter-visualizer (filterCleared)="clearDateRange()" />
    </span>

    <div class="action-buttons">
      <!-- view selection toggle -->
      <section>
        <button
          class="primary"
          [matMenuTriggerFor]="menu"
          aria-label="Open actions menu"
        >
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button class="secondary" (click)="openDateRangePicker()">
            <mat-icon>calendar_month</mat-icon>
            Date Range
          </button>
          <button class="secondary" (click)="openCompareDialog()">
            <mat-icon>compare_arrows</mat-icon>Compare To
          </button>
        </mat-menu>
      </section>
    </div>
  </div>

  <div class="compare-container">
    <ng-container *ngFor="let element of elements" class="element-view">
      <div class="info-card">
        <div *ngIf="element.data" class="overview-card">
          <div class="card-header">{{ element.code }}</div>
          <div class="card-body row">
            <div class="flags">
              <div class="overview-score">
                <span class="flag-title"> Risk activities count </span>
                <span class="indicator" *ngIf="false"></span>
                {{
                  isLoading
                    ? "Loading..."
                    : (element.flagCount | numberAbbreviate)
                }}
              </div>
              <div class="flag-count">
                <span class="flag-title"> Risk % </span>
                <span class="flag-list">
                  <span class="flag-item">
                    <span class="flag-square red"> </span>
                    <span class="visual-percent">
                      {{ element.percentageSum.high }}%
                    </span>
                  </span>
                  <span class="flag-item">
                    <span class="flag-square yellow"> </span>
                    <span class="visual-percent">
                      {{ element.percentageSum.medium }}%
                    </span>
                  </span>
                  <span class="flag-item">
                    <span class="flag-square green"> </span>
                    <span class="visual-percent">
                      {{ element.percentageSum.low }}%
                    </span>
                  </span>
                </span>
              </div>
            </div>
            <div class="summary">
              <div class="summary-title">Executive summary</div>
              {{ complianceElement.exec_summ }}
            </div>
          </div>
        </div>
      </div>

      <ng-container *ngIf="!isLoading && element.data">
        <app-compliance-element-detail
          [data]="element.data"
          [elementName]="complianceElement.name"
          [percentageSum]="element.percentageSum"
        />
      </ng-container>
    </ng-container>
  </div>
</div>
